import { createSlice } from '@reduxjs/toolkit';
import { savingSubscriptionDropsReducer } from './reducers/saving-subscription-drops.reducer';
import { savingSubscriptionUpdateReducer } from './reducers/saving-subscription-update.reducer';
import { initialSubscriptionState } from './state';

export const subscriptionSlice = createSlice({
  name: 'Subscription',
  initialState: initialSubscriptionState,
  reducers: {
    savingDrops: savingSubscriptionDropsReducer,
    savingUpdate: savingSubscriptionUpdateReducer,
  },
});

export const subscriptionReducer = subscriptionSlice.reducer;
